import React from 'react';
import moment from 'moment';
import { ExclamationCircleFilled } from '@ant-design/icons';
import MessageBox from './message-box';
import MessageRich from './message-rich';

import style from './index.less';

const MessageSensitive = props => {
  const { data, onLoad } = props;
  const { rawType, rawContent, time, agentName } = data;
  const render = rawType => {
    let text = '';
    switch (rawType) {
      case 'text':
        text = rawContent;
        break;
      case 'rich_text':
        text = <MessageRich data={rawContent} onLoad={onLoad} />;
        break;
      default:
        text = '';
    }
    return text;
  };
  return (
    <div className={`${style['info-wrapper']} ${style['info-wrapper-right']}`}>
      <ul className={style.info}>
        <li className={style['info-time']}>
          {moment
            .utc(time)
            .local()
            .format('MM-DD HH:mm:ss')}
        </li>
        <li className={style['info-name']}>{agentName}</li>
      </ul>
      <div className={style['stream-content']}>
        <div className={style['content-wrap']}>
          <MessageBox status="msg-wrapper-client">
            <>{render(rawType)}</>
          </MessageBox>
        </div>
      </div>
      <span className={style['extra-info-wrapper']}>
        <ExclamationCircleFilled />
        <span>{'该消息包含违规用语，已被屏蔽'}</span>
      </span>
    </div>
  );
};

export default MessageSensitive;
